import React from 'react';
import styled from 'styled-components';

const Title = styled.h1`
  font-size: 4rem;
  margin-bottom: 3rem;
  @media screen and (max-width: 600px) {
    font-size: 3rem;
  }
`;

const PageTitle = ({ children }) => {
  return <Title>{children}</Title>;
};

export default PageTitle;
